import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./VendorDetail.module.css";
import StarRatings from "react-star-ratings";
import { API_BASE_URL } from "configs/AppConfig";
import VendorCard from "../vendor-card/VendorCard";

/* Swiper */
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import Testimonials from "./testimonials/Testimonials";
import RatingListing from "./rating-listing/RatingListing";
import DefaultSlider from "components/page-content/home-content/DefaultSlider/DefaultSlider";
import LoadingSpinner from "components/UI/loading-spinner/LoadingSpinner";
import useWindowWidth from "helpers/useWindowWidth";

const VendorDetail = () => {
  const { id } = useParams();
  const [vendor, setVendor] = useState(null);
  const [similarVendors, setSimilarVendors] = useState([]);
  const [listings, setListings] = useState([]);
  const navigate = useNavigate();
  const swiperRef = useRef(null); // ← ref for manual navigation
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const width = useWindowWidth();

  useEffect(() => {
    const fetchVendor = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}user/public/vendor/${id}`);
        const data = await res.json();
        setVendor(data?.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchVendors = async () => {
      const res = await fetch(
        `${API_BASE_URL}user/public/vendors?page=1&limit=5`
      );
      const data = await res.json();
      setSimilarVendors(
        data?.data
          ?.filter((v) => v.id !== id)
          .slice(0, width>1600 ? 5 : width > 1050 ? 4 : width > 768 ? 3 : 2)
      );
    };

    fetchVendor();
    fetchVendors();
  }, [id]);

  console.log("vendor value is", vendor);

  useEffect(() => {
    const fetchListings = async () => {
      const res = await fetch(
        `${API_BASE_URL}listing/get/all/public?vendorId=${id}`
      );
      const data = await res.json();
      setListings(
        data?.data?.map((item) => ({
          title: item.name,
          slug: item?.slug,
          city: item.location.locationName,
          state: "Kerala",
          price: item?.availableDates?.[0]?.intervals?.[0]?.price ?? "",
          strikePrice: 15000,
          ratingAvg: item?.ratingAvg,
          reviewCount: item?.reviewCount,
          img: item.images[0],
          categoryName: item.categoryName,
          _id: item._id,
          showPrice: item?.showPrice,
          listingType: item?.listingType,
        }))
      );
    };

    if (id) {
      fetchListings();
    }
  }, [id]);

  //   if (!vendor) return <h4 className={styles.noData}>No Data Found</h4>;

  return (
    <div className={styles.container}>
      {loading && !vendor && <LoadingSpinner />}
      {!loading && !vendor?.name && (
        <h4 className={styles.noData}>No Data Found</h4>
      )}
      {!loading && vendor === 0 && !error && (
        <h4 className="home-error">No Vendors Found</h4>
      )}
      {/* ───── Cover Carousel ───── */}
      {vendor?.name && !loading && (
        <>
          <div className={styles.coverWrapper}>
            <div className={styles.left}>
              <img src={vendor?.profileImage} className={styles.profileImage} />
              <h2 className={styles.name}>{vendor?.name}</h2>
              <div className={styles.locationDiv}>
                <img src="/img/packages/location_icon.svg" alt="location" />
                <p className={styles.location}>
                  {vendor?.location?.locationName}
                </p>
              </div>
              <div className={styles.rating}>
                <span>{vendor?.ratingSummary?.averageRating}</span>
                <StarRatings
                  rating={Number(vendor?.ratingSummary?.averageRating) || 0}
                  starRatedColor="rgb(255, 215, 0)"
                  numberOfStars={5}
                  starDimension="20px"
                  starSpacing="2px"
                  name="rating"
                />
              </div>
              <div className={styles.categories}>
                {vendor?.categories?.map((cat) => (
                  <span key={cat._id} className={styles.categoryTag}>
                    {cat?.categoryName}
                  </span>
                ))}
              </div>
            </div>
          <div className={styles.rightSlider}>

            <Swiper
              modules={[Navigation, Autoplay]}
              autoplay={{ delay: 6000, disableOnInteraction: false }}
              loop
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              className={styles.coverSwiper}
            >
              {vendor?.image?.map((img) => (
                <SwiperSlide key={img.url}>
                  <img
                    src={img.url}
                    alt={vendor.name}
                    className={styles.coverImg}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Right‑side arrow */}
            <img
              src="/img/right-arrow.svg"
              alt="next"
              className={styles.nextArrow}
              onClick={() => swiperRef.current?.slideNext()}
            />
          </div>
          </div>

          {/* ───── Details Section ───── */}
          <div className={styles.details}>
            {/* <div className={styles.left}>
              <img src={vendor?.profileImage} className={styles.profileImage} />
              <h2 className={styles.name}>{vendor?.name}</h2>
              <div className={styles.locationDiv}>
                <img src="/img/packages/location_icon.svg" alt="location" />
                <p className={styles.location}>
                  {vendor?.location?.locationName}
                </p>
              </div>
              <div className={styles.rating}>
                <span>{vendor?.ratingSummary?.averageRating}</span>
                <StarRatings
                  rating={Number(vendor?.ratingSummary?.averageRating) || 0}
                  starRatedColor="rgb(255, 215, 0)"
                  numberOfStars={5}
                  starDimension="20px"
                  starSpacing="2px"
                  name="rating"
                />
              </div>
              <div className={styles.categories}>
                {vendor?.categories?.map((cat) => (
                  <span key={cat._id} className={styles.categoryTag}>
                    {cat?.categoryName}
                  </span>
                ))}
              </div>
            </div> */}

            <div className={styles.right}>
              <h3>About {vendor?.name}</h3>
              <div
                className={styles.aboutHtml}
                dangerouslySetInnerHTML={{ __html: vendor?.description }}
              />
            </div>
          </div>
        </>
      )}

      {/* ───── Listings ───── */}

      {listings?.length > 0 && vendor?.name && (
        <DefaultSlider
          // data={data}
          data={listings}
          title="Packages"
          containerClass={styles.slider}
        />
      )}

      {/* ───── Testimonials ───── */}

      {vendor?.ratingSummary?.averageRating && vendor?.name && (
        <RatingListing
          reviews={vendor?.ratingSummary?.reviews}
          details={{
            ratings: [vendor?.ratingSummary?.breakdown],
            ratingAvg: vendor?.ratingSummary?.averageRating,
            reviewCount: vendor?.ratingSummary?.totalReviews,
          }}
        />
      )}

      {/* ───── Similar Vendors ───── */}
      {vendor?.name && !loading && (
        <div className={styles.similarSection}>
          <div className={styles.sectionHeader}>
            <h3>Similar Vendors</h3>
            <span
              className={styles.viewAll}
              onClick={() => navigate("/vendors")}
            >
              View All
            </span>
          </div>
          <div className={styles.cardGrid}>
            {similarVendors.map((v) => (
              <VendorCard
                key={v.id}
                image={v.profileImage}
                title={v.name}
                location={v.location?.locationName}
                category={v.categories}
                slug={v.slug}
                id={v.id}
                rating={v.rating}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorDetail;
